<template>
	<div class="mobileRecruit" id="mobileRecruit">
		<div class="topFixed">
			<div class="top">
				<div class="nav" @click="back()"></div>
				<h1 class="logo">
					红匣子游戏
				</h1>
				<div class="lang-nav">
				</div>
				<!-- <div :class="langNavShow? 'lang-nav on' : 'lang-nav'" @click="langNavShow = !langNavShow">
					<ul>
						<li :class="lang == 'zh-cn'? 'on' : ''"><a @click="setLang('zh-cn')">简中</a></li>
						<li :class="lang == 'zh-hk'? 'on' : ''"><a @click="setLang('zh-hk')">繁中</a></li>
						<li :class="lang == 'en-us'? 'on' : ''"><a @click="setLang('en-us')">English</a></li>
						<li :class="lang == 'ja-jp'? 'on' : ''"><a @click="setLang('ja-jp')">日語</a></li>
						<li :class="lang == 'ko-kr'? 'on' : ''"><a @click="setLang('ko-kr')">한국어</a></li>
					</ul>
				</div> -->
			</div>
		</div>
		<div class="mian">
			<div class="m m_1" id="m_1">
				<img src="@/assets/imgs/mobile/banner.jpg" width="100%"/>
			</div>
			<div class="m m_2" id="m_2">
				<div class="m_2_c">
					<input type="text" v-model="keyword" placeholder="请输入职位关键字">
					<a @click="positionList(1, 5)">搜索</a>
				</div>
			</div>
			<div class="m m_3" id="m_3">
				<ul v-if="tableDataShow" class="m_3_c">
					<li v-for="(item, index) in tableData" :key="index" @click="detailRow(item)">
						<p>{{ item.job_name }}</p>
						<span>岗位详情</span>
					</li>
				</ul>
				<div v-else class="m_3_c_nodata">
					<p>暂无消息</p>
				</div>
			</div>
			<div class="m m_8" id="m_8">
				<div class="m_8_c">
					<ul>
						<li><a @click="link('m_3')">{{ langConfig.footNav[0] }}</a></li>|
						<li><a @click="link('m_6')">{{ langConfig.footNav[1] }}</a></li>|
						<li><a @click="link('m_2')">{{ langConfig.footNav[2] }}</a></li>|
						<li><a :href="langConfig.footLink1" target="_blank">{{ langConfig.footNav[3] }}</a></li>|
						<li><a :href="langConfig.footLink2" target="_blank">{{ langConfig.footNav[4] }}</a></li>
					</ul>
					<p>
						{{ langConfig.footInfo }}<br>
						{{ langConfig.footIcp }}<br>
						{{ langConfig.footAddress }}<br>
						{{ langConfig.footEmail2 }}<img src="../../assets/imgs/email.png"/>
					</p>
				</div>
			</div>
		</div>
		<div class="popupbox" v-if="popupboxShow">
				<div class="popup">
					<div class="popupC">
						<div class="popupTitle">
							<span @click="popupboxShow=false">
								<i></i>
								<i></i>
							</span>
						</div>
						<div class="popupContent">
							<p class="title_1">{{ recruitDetail.job_name }}</p>
							<p class="detail_1">{{ recruitDetail.address }} / {{ recruitDetail.is_full_time }}</p>
							<!-- <p class="title_1">{{ recruitDetail.data1.title }}</p> -->
							<p class="title_1">职位描述</p>
							<p class="detail_2" v-html="recruitDetail.description"></p>
							<!-- <p class="title_1">{{ recruitDetail.data2.title }}</p> -->
							<p class="title_1">职位要求</p>
							<p class="detail_2" v-html="recruitDetail.requirements"></p>
							<p class="title_2">简历请发送至：{{ recruitDetail.mail }}</p>
						</div>
						<div class="popupBtn">
							<!-- <a :href="recruitDetail.mail" target="_blank">{{ recruitDetail.mail }}</a> -->
							<a :href="recruitDetail.link" target="_blank">{{ recruitDetail.link_name }}</a>
						</div>
					</div>
				</div>
			</div>
	</div>
</template>

<script>
import Vue from "vue";
import { getPositionList } from "@/api";
import "@/assets/styles/index_pc.scss";
import langzhcn from '../pc/config/zh-cn.json';
import { EscapeHtml } from '@/utils'

// 防刷
import debounce from "lodash/debounce";

// 滚动条// 引入
var VueScrollTo = require("vue-scrollto");

export default {
    name: "mobileHome",
    components: {
    },
    data () {
			return {
				recruitInfo: [],
				popupboxShow: false,
				tableData: [],
				keyword: '',
				langConfig: langzhcn,
				tableDataShow: true
			};
    },
    mounted () {
			this.handleLoading();
    },
    methods: {
			/**
			 * @function handleLoading 处理加载
			 */
			async handleLoading(){
				console.log("初始化");
				this.positionList(1, 10000)
			},

			/**
			 * @function link 跳转位置
			 */
			//js
			link(id) {
				VueScrollTo.scrollTo( document.getElementById(id), 1000, {offset: -110});
			},
			
			// 岗位列表
			positionList(pageIndex, pageSize) {
				let positionData = {
					lang: 'zh-cn', 
					pageSize: pageSize, 
					pageIndex: pageIndex,
					keyword: this.keyword
				};
				getPositionList(positionData)
					.then(res => {
						console.log("岗位列表成功", res);
						console.log("岗位列表成功", res.data.list);
						if(res.data.total){
							this.tableData = res.data.list;	
							this.tableDataShow = true;					
						} else {
							this.tableDataShow = false;
						}
					})
					.catch(err => {
						console.log("岗位列表失败", err);
					});
			},
			
			// 岗位详情
			detailRow(data) {
				console.log('detailRow', data),
				this.popupboxShow = true;
				this.recruitDetail = data;
				this.recruitDetail.description = EscapeHtml(data.description);
				this.recruitDetail.requirements = EscapeHtml(data.requirements);
				console.log('detailRow2', this.recruitDetail)
			},

			// back
			back() {
				this.$router.back()
				console.log("back")
			}
    }
};
</script>

<style lang="scss">
@import "../../assets/styles/index_mobile.scss";
</style>
